//Copyright 2018 Nathan Moore

export const CREATE_NODE = "CREATE_NODE";
export const UPDATE_NODE = "UPDATE_NODE";
export const DELETE_NODE = "DELETE_NODE";
export const FETCH_NODES = "FETCH_NODES";
